/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

// ==============================================================================
// Provide a common backdrop / window focus system.
// ------------------------------------------------------------------------------

(function($, window) {
	return window.Modal = {
		windowShade: null,
		activeModal: null,
		positionElement: null,
		canClose: null,
		queue: [],
		initted: false,
		shadeDefault: true,

		// Matched with $animationSpeed in modal.scss
		animationSpeed: 200,

		init() {
			if (this.initted) {
				return;
			}
			this.initted = true;

			// convenience shortcuts
			this.body = $("body");
			this.window = $(window);
			this.windowShade = $("#windowshade");

			//if the browser is ie6 or ie7, disable showing the windowshade by default.
			if (this.body.hasClass("ie6") || this.body.hasClass("ie7")) {
				this.shadeDefault = false;
			}

			// Center all visible modals
			$(".modal").each((i, el) => {
				let modal = $(el);
				if (modal.hasClass("show")) {
					let id = modal.attr("id");
					return this.center(id);
				} else {
					return modal.hide();
				}
			});

			return this.listen();
		},

		listen() {
			return (
				this.windowShade
					// close on click -- deprecated
					.on("click", ev => {
						if (!this.hasActive()) {
							return;
						}
						// use target to find the precise element that was clicked
						let target = $(ev.target);
						if (target.attr("id") === this.windowShade.attr("id")) {
							return this.close();
						}
					})
			);
		},

		// Helpers
		// ----------------------------------------------------------------------

		hasActive() {
			return this.activeModal != null ? this.activeModal.length : undefined;
		},

		getActiveCloseButton() {
			return this.activeModal.find("> .close");
		},

		// Open a new window, raise shade by default, close existing active window.
		open(modalId, showShade = this.shadeDefault, positionElementId = false, canClose = true) {
			// Window ID required.
			if (showShade == null) {
				showShade = this.shadeDefault;
			}

			if (!modalId || this.body.hasClass("no-actions")) {
				return;
			}

			if (typeof OkPay !== "undefined" && OkPay !== null) {
				this.reopenOkPay = OkPay.hide();
			}

			// let's not be a jackass about what you can or can't pass in
			if (modalId.indexOf("#") === 0) {
				modalId = modalId.slice(1);
			}

			if (positionElementId && positionElementId.indexOf("#") == 0) {
				positionElementId = positionElementId.slice(1);
			}

			// Don't try to open the same modal twice
			if (this.hasActive() && this.activeModal.attr("id") === modalId) {
				return;
			}

			// clear any timeouts that may exist from previous modal closes
			if (this.closingTimeout != null) {
				clearTimeout(this.closingTimeout);
			}

			// if we're on ie 6 or 7, make sure we don't show the windowshade!
			if (!this.shadeDefault) {
				showShade = false;
			}

			this.canClose = canClose;

			// Disable current active modal, if one's open.
			if (this.hasActive()) {
				this.queue.push(this.activeModal);
				this.activeModal.removeClass("show");
				this.activeModal = null;
			}

			this.activeModal = $(`#${modalId}`);

			if (!this.activeModal.length) {
				return;
			}

			this.noAppend = this.activeModal.hasClass("no-append");

			this.activeModal.show().addClass("show").trigger("modalopen");

			this.positionElement = $(`#${positionElementId}`);

			if (positionElementId && this.positionElement.length) {
				this.positionElement.addClass('modal-up');
				Modal.position(modalId);
			}

			Modal.center(modalId);
			this.activeModal.showShade = showShade;

			if (showShade) {
				return this.openShade();
			}
		},

		// Close a specific window, or if no arg, close whatever window is open.
		close(modalId) {
			let modal;

			if (this.closeHandler != null) {
				this.closeHandler(modalId);
			}

			if (!this.canClose) {
				return;
			}

			let removeFromShade = false;

			// If an ID is specified, try hiding that.
			if (modalId) {
				if (!this.hasActive() || modalId !== this.activeModal.attr("id")) {
					return false;
				}

				modal = $(`#${modalId}`);
				// Only remove activeModal if we're closing in proper order.
				if (this.hasActive() && this.activeModal.attr("id") === modalId) {
					if (this.activeModal.showShade) {
						removeFromShade = true;
					}

					this.activeModal = null;
				}

				// Otherwise, whatever's active. If there's more in the queue show it.
			} else if (this.hasActive()) {
				modal = this.activeModal;

				if (this.activeModal.showShade) {
					removeFromShade = true;
				}

				this.activeModal = null;
			}

			if (!modal) {
				return;
			}

			if (this.positionElement) {
				this.positionElement.removeClass('modal-up');
				this.positionElement = null;
			}

			modal.removeClass("show");
			let prevModal = this.queue.pop();

			if (!this.reopenOkPay && (!prevModal || !prevModal.showShade)) {
				this.closeShade();
			}

			// reopen okpay if we closed it earlier
			// and exit early so we don't accidentally hide okpay
			if (this.reopenOkPay) {
				OkPay.show();
				this.reopenOkPay = false;
				return;
			}

			// Delay messing with the markup until all is hidden
			let modalToRemove = this.activeModal;
			return (this.closingTimeout = setTimeout(() => {
				modal.hide();
				// Open up the previous modal, if available.
				if (prevModal) {
					Modal.open(prevModal.attr("id"), prevModal.showShade);
				}
				if (removeFromShade) {
					this.windowShade.parent().append(modalToRemove);
				}
				return modal.trigger("modalclose");
			}, this.animationSpeed));
		},

		setCloseHandler(handler) {
			return (this.closeHandler = handler);
		},

		closeAll() {
			if (this.hasActive()) {
				this.activeModal.removeClass("show");
				this.windowShade.removeClass("show");
				this.body.removeClass("noscroll");
				this.queue = [];
				this.activeModal = null;
				this.positionElement = null;
			}
		},


		// shade actions
		// ----------------------------------------------------------------------

		openShade() {
			// prototype can call modal.init() before the dom is loaded, so windowshade
			// ends up being undefined. so define windowshade it it's not.
			if (!this.windowShade || !this.windowShade.length) {
				this.windowShade = $("#windowshade");
			}

			this.body.addClass("noscroll");

			// Append performs a move when the element already exists (as in this case)
			if (this.hasActive() && !this.noAppend) {
				this.activeModal.parent().append(this.windowShade);
			}

			// I think this forces a dom redraw?
			this.windowShade.css("opacity");
			this.windowShade.addClass("show").append(this.activeModal);
			return (this.shadeOpen = true);
		},

		closeShade() {
			this.windowShade.removeClass("show");
			this.body.removeClass("noscroll");
			return (this.shadeOpen = false);
		},

		// Load content via AJAX into the content container. Response should contain markup.
		//
		// modalId 	- ID attribute of the modal
		// path			- Path of the endpoint that'll provide the content.
		// data			- Object to send as request data.
		// callback	- Success callback for the request.
		loadContent(modalId, path, data, callback) {
			let modal;
			if (modalId) {
				modal = $(`#${modalId}`);
			} else {
				modal = this.activeModal;
			}
			if (!modal || !modal.length) {
				return;
			}

			// Clear out any existing content, and give us a nice spinner gif.
			Modal.setContent(modal.attr("id"), "");
			let loader = new OkLoader(modal);
			loader.start();

			Modal.center(modalId);
			return $.ajax({
				url: path,
				data,
				accepts: "text/html",
				cache: false,

				success: requestData => {
					loader.stop();
					this.setContent(modal.attr("id"), requestData);
					if (callback != null) {
						callback();
					}
					return this.center(modalId);
				},
			});
		},

		// Add markup to the content section of the modal
		setContent(modalId, content) {
			let contentContainer = $(`#${modalId}`).find(".content");
			if (content.length !== 0) {
				contentContainer.html(content);
				return contentContainer.removeClass("empty");
			} else {
				contentContainer.html("");
				return contentContainer.addClass("empty");
			}
		},

		setTitle(modalId, title) {
			return $(`#${modalId}`).find("> h2.title").html(title);
		},

		setDescription(modalId, desc) {
			return $(`#${modalId}`).find("> h2.desc").html(desc);
		},

		// Given an element, orient the modal to its center
		position(modalId) {
			const widthMod = this.positionElement.width() / 2;
			const heightMod = this.positionElement.height() / 2;
			const windowTop = this.window.scrollTop();
			const offset = this.positionElement.offset();
			let modal;

			if (modalId) {
				modal = $(`#${modalId}`);
			} else {
				modal = this.activeModal;
			}

			if (!modal || !modal.length) {
				return;
			}

			modal.css({
				top: offset.top + heightMod - windowTop,
				left: offset.left + widthMod,
			});
		},

		// Vertically and horizontally center a modal. Centers activeModal if no
		// ID is specified.
		center(modalId) {
			let modal;
			if (modalId) {
				modal = $(`#${modalId}`);
			} else {
				modal = this.activeModal;
			}

			if (!modal || !modal.length || modal.hasClass("nocenter")) {
				return;
			}

			return modal.css("marginLeft", Math.round(-modal.innerWidth() / 2));
		},

		verticallyCenter(modalId) {
			let modal;
			if (modalId) {
				modal = $(`#${modalId}`);
			} else {
				modal = this.activeModal;
			}

			if (!modal || !modal.length) {
				return;
			}

			let windowtop = this.window.scrollTop();
			let windowheight = this.window.height();
			let modalheight = modal.outerHeight();
			let modaltop = windowtop + (windowheight - modalheight) / 2;

			// subtract the offset parent's top offset
			let offsetparent = modal.offsetParent();
			if (offsetparent && offsetparent.length) {
				modaltop -= offsetparent.offset().top;
			}

			return modal.css("top", modaltop);
		},
	};
})(jQuery, window);

const Modal = window.Modal;
export default Modal;



// WEBPACK FOOTER //
// ./src/legacy/modal.js